
















































import {
  computed,
  defineComponent,
  ref,
  useRoute,
  useRouter
} from "@nuxtjs/composition-api";

export default defineComponent({
  name: "OderHeader",
  components: {},
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();

    const productConfiguration = ref(route.value.query);
    const paymentMethod =
      productConfiguration.value.method.toString().toUpperCase() || "";
    const back = () => {
      emit("cancelPayment", true);
    };

    const backHome = () => {
     router.push({ path: "/" });
    };

    return { back, paymentMethod, backHome };
  },
});
